{
  "type": "object",
  "name": "voucher",
  "class": [
    "py-4",
    {
      "class": "!bg-danger-300",
      "rule": {
        "name": "not",
        "rule": {
          "name": "property",
          "property": "detail.kzfreigabe",
          "rule": {
            "name": "equal",
            "value": "J"
          }
        }
      }
    }
  ],
  "definitions": [
    {
      "type": "group",
      "title": "Fremdbelegdatum",
      "control": "div",
      "definitions": [
        {
          "type": "group",
          "control": "div",
          "class": "flex flex-row w-full",
          "definitions": [
            {
              "type": "date",
              "title": "",
              "name": "detail.belegdatum",
              "class": ""
            },
            {
              "type": "text",
              "title": "",
              "text": "Korr. vorhanden",
              "class": "bg-accent rounded-full px-2 ml-2 whitespace-nowrap",
              "visible": {
                "name": "property",
                "property": "detail.belastungVorhanden",
                "rule": {
                  "name": "boolean",
                  "value": true
                }
              }
            }
          ]
        }
      ]
    },
    {
      "type": "entity",
      "title": "Lieferant",
      "name": "detail.ktostamm",
      "endpoint": "",
      "format": "{{number}} - {{name}}",
      "class": "font-bold"
    },
    {
      "type": "string",
      "title": "Objekt (Projektnummer in TR/SR)",
      "name": "detail.objekt",
      "format": "{{objekt}} - {{bezeichnung}}"
    },
    {
      "type": "entity",
      "title": "Baustelle",
      "name": "detail.ktostamm_lief",
      "format": "{{number}} - {{name}}"
    },
    {
      "type": "string",
      "title": "Belegart",
      "name": "detail.belegartKopferw",
      "class": "whitespace-nowrap"
    },
    {
      "type": "string",
      "title": "StreckenNr.",
      "name": "detail.belegnummer"
    },
    {
      "type": "string",
      "title": "FremdbelegNr.",
      "name": "detail.bezugsnummer"
    },
    {
      "type": "date",
      "title": "Fälligkeit",
      "name": "detail.faelligkeitMitglied"
    },
    {
      "type": "currency",
      "title": "Netto",
      "name": "detail.nettoBetrag",
      "code": "EUR",
      "titleClass": "text-right"
    },
    {
      "type": "currency",
      "title": "Brutto",
      "name": "detail.bruttoBetrag",
      "code": "EUR",
      "titleClass": "text-right"
    }
  ]
}
